// Auth/session storage helpers.
//
// Logout and session-expiry paths call localStorage.clear(), which also wipes
// one-time onboarding markers we intentionally want to survive across sessions
// (e.g. the "admin has seen the Setup Center intro" flag). clearAuthStorage()
// clears everything EXCEPT those namespaced onboarding keys so "first login
// only" behaviour holds after a logout or token expiry.

const PRESERVE_PREFIXES = ['setupIntroSeen:'];

export const clearAuthStorage = (): void => {
  try {
    const preserved: Array<[string, string]> = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && PRESERVE_PREFIXES.some((p) => key.startsWith(p))) {
        const val = localStorage.getItem(key);
        if (val != null) preserved.push([key, val]);
      }
    }
    localStorage.clear();
    preserved.forEach(([k, v]) => localStorage.setItem(k, v));
  } catch {
    // Storage unavailable (private mode / quota) — best effort.
    try { localStorage.clear(); } catch { /* ignore */ }
  }
};
